const FolderNew = () => (
  <>
    <path
      fill="#fff"
      d="M4 7a1.5 1.5 0 0 1 1.5-1.5h3.142a1.5 1.5 0 0 1 1.272.705l.075.12a2.5 2.5 0 0 0 2.12 1.175H18.5A1.5 1.5 0 0 1 20 9v3a.5.5 0 0 0 .5.5M20 18.5h-2.5a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.212.144-.356a.48.48 0 0 1 .356-.143H20V15q0-.213.144-.356a.49.49 0 0 1 .357-.144q.212 0 .356.144A.49.49 0 0 1 21 15v2.5h2.5q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .212-.144.356a.49.49 0 0 1-.356.143H21V21q0 .212-.144.356a.49.49 0 0 1-.357.144.48.48 0 0 1-.356-.144A.49.49 0 0 1 20 21z"
    />
  </>
)
export default FolderNew
